export const MOBILE_SETTORE = { "Addetto di banchina": "Addetto di banchina", "Addetto torre di controllo": "Addetto di banchina", Manutentore: "Manutentore", Nostromo: "Nostromo" };
const LABEL = { "Addetto di banchina": "Banchina", Manutentore: "Manutentori", Nostromo: "Nostromo" };

export const settoreOf = (name) => MOBILE_SETTORE[name] || name;
export const isMobileSettore = (s) => Object.values(MOBILE_SETTORE).includes(s);
export const settoreLabel = (s) => LABEL[s] || s;
export const shiftApi = (s) => (isMobileSettore(s) ? "/shift-reports" : "/web/shift-reports");
export const editLink = (r) => `/report/shift-new?id=${r.id}${isMobileSettore(r.settore) ? "" : "&src=web"}`;

const uniq = (a) => [...new Set(a)];

export function settoriFor(profiles, roles, admin) {
  const shift = (profiles || []).filter((p) => p.name !== "Direttore" && p.permissions?.["report.shift"]);
  const mine = admin ? [] : uniq(shift.filter((p) => roles.includes(p.name)).map((p) => settoreOf(p.name)));
  const all = uniq(shift.map((p) => settoreOf(p.name)));
  const visible = admin ? all
    : uniq([...mine, ...shift.filter((p) => (p.responsabili || []).some((r) => roles.includes(r))).map((p) => settoreOf(p.name)), ...(roles.includes("Nostromo") ? ["Addetto di banchina"] : [])]);
  return { mine, visible };
}
